(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["oaf-magnetic-leaf-info"] && !Shopify.designMode) return;
  try {
    (function () {
  function update() {
    var guides = document.querySelectorAll('[data-oaf-magnetic-guide]');
    if (!guides.length) return;
    if (window.oafNoMagneticSkirts) { guides.forEach(function (guide) { guide.hidden = true; }); return; }
    var root = document.getElementById('itoris_dynamicproductoptions');
    if (!root) return;
    var hasLeaves = Array.from(root.querySelectorAll('.field[id^="dynamic_option_id_"]')).some(function (node) {
      var label = node.querySelector(':scope > label');
      if (!label || !/^(?:extension leaves|leaves)\s*\*?\s*$/i.test(label.textContent.trim())) return false;
      return node.querySelectorAll('input[type="radio"], select option').length > 1;
    });
    guides.forEach(function (guide) { guide.hidden = !hasLeaves; });
  }
  update();
  var observer = new MutationObserver(update);
  observer.observe(document.body, {childList: true, subtree: true});
  document.addEventListener('shopify:section:load', update);
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["oaf-manufacturer-leaf-guide"] && !Shopify.designMode) return;
  try {
    (function () {
  function update() {
    var guide = document.querySelector('.oaf-manufacturer-leaf-guide');
    var root = document.getElementById('itoris_dynamicproductoptions');
    if (!guide || !root) return;
    function selected(name) {
      var node = Array.from(root.querySelectorAll('.field')).find(function (f) {
        var label = f.querySelector(':scope > label');
        return label && label.textContent.replace(/\*/g, '').trim().toLowerCase() === name;
      });
      if (!node) return null;
      var select = node.querySelector('select');
      var input = node.querySelector('input:checked');
      var label = input && node.querySelector('label[for="' + CSS.escape(input.id) + '"]');
      var text = select ? select.options[select.selectedIndex].textContent : label && label.textContent;
      var match = text && text.match(/^\s*(\d+)/);
      return match ? match[1] : null;
    }
    var width = selected('width') || selected('diameter') || selected('size');
    var length = selected('length');
    var row = Array.from(guide.querySelectorAll('tbody tr')).find(function (r) {
      var values = r.cells[0].textContent.match(/\d+/g) || [];
      return values[0] === width && (values.length === 1 || values[1] === length);
    });
    var box = guide.querySelector('[data-oaf-selected-leaf-guide]');
    var text = row ? row.cells[0].textContent + ': ' + guide.querySelector('thead th:nth-child(2)').textContent + ' — ' + row.cells[1].textContent + '. ' + guide.querySelector('thead th:nth-child(3)').textContent + ' — ' + row.cells[2].textContent + '.' : box.dataset.fallback;
    if (!box.dataset.fallback) box.dataset.fallback = box.textContent;
    if (text && box.textContent !== text) box.textContent = text;
  }
  document.addEventListener('change', update);
  document.addEventListener('input', update);
  document.addEventListener('shopify:section:load', update);
  new MutationObserver(update).observe(document.body, {subtree:true,childList:true});
  update();
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["oaf-rh-table-guides"] && !Shopify.designMode) return;
  try {
    (function(){
  function update(){
    var box=document.querySelector('[data-oaf-rh-shapes]');
    var root=document.getElementById('itoris_dynamicproductoptions');
    if(!box||!root)return;
    var field=Array.from(root.querySelectorAll('.field, tr.fields')).find(function(f){
      var label=f.querySelector(':scope > label, label.required');
      return label && /^(?:(?:table|top)\s*)?shapes?\s*\*?$/i.test(label.textContent.trim());
    });
    if(!field)return;
    var choices=[];
    field.querySelectorAll('input[type="radio"],input[type="checkbox"]').forEach(function(input){
      var label=field.querySelector('label[for="'+CSS.escape(input.id)+'"]');
      if(!label)return;
      var img=label.querySelector('img')||input.closest('.choice')?.querySelector('img');
      var text=label.textContent.replace(/\s+/g,' ').trim();
      if(text||img)choices.push({text:text,src:img?(img.currentSrc||img.src):''});
    });
    if(!choices.length)field.querySelectorAll('select option').forEach(function(o){if(o.value)choices.push({text:o.textContent.trim(),src:''});});
    if(!choices.length)return;
    var signature=JSON.stringify(choices);
    if(box.dataset.signature===signature)return;
    box.dataset.signature=signature;
    box.replaceChildren();
    box.classList.add('oaf-rh-shape-grid');
    choices.forEach(function(choice){
      var name=choice.text.split(/\s*\+\s*\$/)[0].trim();
      var fig=document.createElement('figure');fig.className='oaf-rh-shape';
      if(choice.src){
        var img=document.createElement('img');img.src=choice.src;img.alt=name+' top shape';img.loading='lazy';img.width=120;img.height=120;
        fig.appendChild(img);
      }
      var cap=document.createElement('figcaption');cap.textContent=name;fig.appendChild(cap);box.appendChild(fig);
    });
  }
  document.addEventListener('change',update);
  document.addEventListener('shopify:section:load',update);
  new MutationObserver(update).observe(document.body,{childList:true,subtree:true});
  update();
})();

/* Round/diameter tables: seating estimate + leaf-guide highlight (DPO size label "Round", "Diameter" or "Size"). */
(function(){
  var SIZE_LABELS=['round','diameter','size','table size'];
  function clean(s){return String(s||'').replace(/\s+/g,' ').trim();}
  function fieldFor(names){
    var root=document.getElementById('itoris_dynamicproductoptions'); if(!root)return null;
    return Array.from(root.querySelectorAll('.field[id^="dynamic_option_id_"], tr.fields')).find(function(f){
      var l=f.querySelector(':scope > label, label.required'); return l && names.indexOf(clean(l.textContent).replace(/\s*\*\s*$/,'').toLowerCase())>-1;
    })||null;
  }
  function picked(f){
    if(!f)return '';
    var i=f.querySelector('input[type="radio"]:checked,input[type="checkbox"]:checked');
    if(i){var l=f.querySelector('label[for="'+CSS.escape(i.id)+'"]');return clean(l?l.textContent:'');}
    var s=f.querySelector('select');return s&&s.value?clean(s.options[s.selectedIndex].textContent):'';
  }
  function num(t){var m=String(t||'').split(/\+|\$/)[0].match(/\d+(?:\.\d+)?/);return m?Number(m[0]):null;}
  function words(t){t=clean(t).toLowerCase();if(!t||/none|solid|zero/.test(t))return 0;var w={one:1,two:2,three:3,four:4,five:5,six:6};for(var k in w)if(new RegExp('\\b'+k+'\\b').test(t))return w[k];return num(t)||0;}
  function seatsRound(d){return d<36?'2':d<=42?'4':d<=48?'4–6':d<=54?'6':d<=60?'6–8':d<=66?'8':'8–10';}
  var ext={48:'4',54:'4–6',60:'4–6',66:'6',72:'6–8',78:'6–8',84:'8',90:'8',96:'8–10',102:'8–10',108:'10',114:'10',120:'10–12'};
  function update(){
    var guide=document.querySelector('[id^="OafSeatingGuide"]');
    if(!guide||fieldFor(['width'])||fieldFor(['length']))return;
    var sf=fieldFor(SIZE_LABELS); var d=num(picked(sf)); if(!d)return;
    var leaves=words(picked(fieldFor(['extension leaves'])))*12+words(picked(fieldFor(['18" butterfly leaves'])))*18;
    var sizeEl=guide.querySelector('.oaf-seating-guide__size'),capEl=guide.querySelector('.oaf-seating-guide__capacity');
    var size=leaves?d+'″ × '+(d+leaves)+'″ extended':d+'″ round';
    var seats=leaves?(ext[d+leaves]||''):seatsRound(d);
    var cap=seats?'Comfortably seats approximately '+seats:'Seating estimate unavailable for this configuration.';
    if(sizeEl&&sizeEl.textContent!==size)sizeEl.textContent=size;
    if(capEl&&capEl.textContent!==cap)capEl.textContent=cap;
    var box=document.querySelector('[data-oaf-selected-leaf-guide]');
    if(box){var row=Array.from(document.querySelectorAll('.oaf-manufacturer-leaf-guide tbody tr')).find(function(r){var v=r.cells[0].textContent.match(/\d+/g)||[];return Number(v[0])===d&&v.length===1;});
      if(row){var t=row.cells[0].textContent+': '+row.cells[1].textContent+' leaves max. Self-storage — '+row.cells[2].textContent+'.';if(box.textContent!==t)box.textContent=t;}}
  }
  function start(){
    update();
    var root=document.getElementById('itoris_dynamicproductoptions');
    if(!root){setTimeout(start,300);return;}
    root.addEventListener('change',function(){setTimeout(update,30);});
    root.addEventListener('click',function(){setTimeout(update,80);});
    var g=document.querySelector('[id^="OafSeatingGuide"]');
    if(g)new MutationObserver(function(){setTimeout(update,0);}).observe(g,{subtree:true,childList:true,characterData:true});
    setTimeout(update,500);setTimeout(update,1500);
  }
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',start);else start();
})();

/* Seating guide wording: works whether the options sit above or below the guide (mobile). */
(function(){
  var swaps=[['Choose your table options above','Select your table size'],['Your finished size and seating estimate will appear here.','Your finished size and seating estimate will update as you choose options.']];
  function fix(g){g.querySelectorAll('.oaf-seating-guide__size,.oaf-seating-guide__capacity').forEach(function(el){swaps.forEach(function(s){if(el.textContent.trim()===s[0])el.textContent=s[1];});});}
  function start(){
    var g=document.querySelector('[id^="OafSeatingGuide"]');
    if(!g){if(document.readyState!=='complete')setTimeout(start,300);return;}
    fix(g);new MutationObserver(function(){fix(g);}).observe(g,{subtree:true,childList:true,characterData:true});
  }
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',start);else start();
})();
  } catch(e) { console.error(e); }
})();

})();
